module.exports = __webpack_public_path__ + "static/media/Platformicon01@3x.6f105e7e.png";